const driverFieldsToPath = {
  name: "first_name",
  category: "driver_license.categories",
  number: "phone_number",
  email: "email",
  expiry: "driver_license.expiry_date",
};

export const getOrderByValueDriver = (field) =>
  driverFieldsToPath[field] || field;
